<template>
    <v-autocomplete
        v-model="obraSocialId"
        variant="solo"
        :items="obrasSociales"
        item-title="nombre"
        item-value="id"
        :rules="obligatorio"
        :loading="cargandoOS"
        label="ObraSocial"
        required
        class="asterisco"
        @update:model-value="seleccionarObraSocial"
    >
    </v-autocomplete>
</template>
<style src="../assets/general.css"></style>
<script>
    import { obligatorio } from '@/_helpers/rules';
    import PacienteService from '@/api/PacienteService';

    const pacienteService = new PacienteService();

    export default {
        data() {
            return {
                obraSocialId: null,
                obrasSociales: [],
                cargandoOS: false,
                obligatorio : obligatorio
            }
        },
        mounted() {
            this.cargarObrasSociales();
        },
        methods:{
            async cargarObrasSociales() {
                this.cargandoOS = true;
                const response = await pacienteService.getObrasSocialesTotales();
                if(response && response.status === 200) {
                    this.obrasSociales = response.data;
                }
                this.cargandoOS = false;
            },
            seleccionarObraSocial(){
                this.$emit('os-seleccionada', this.obraSocialId);
            }
        }
    }
</script>